import { render, staticRenderFns } from "./ArrayRowFields.vue?vue&type=template&id=019e86a6&lang=pug&"
import script from "./ArrayRowFields.vue?vue&type=script&lang=js&"
export * from "./ArrayRowFields.vue?vue&type=script&lang=js&"
import style0 from "./ArrayRowFields.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/authoring/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('019e86a6')) {
      api.createRecord('019e86a6', component.options)
    } else {
      api.reload('019e86a6', component.options)
    }
    module.hot.accept("./ArrayRowFields.vue?vue&type=template&id=019e86a6&lang=pug&", function () {
      api.rerender('019e86a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inspector/widget/ArrayRowFields.vue"
export default component.exports